<template>
    <div>
        <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />
        <h1 class="u-m0">
            <span class="u-screenreader">
                Претрага по подносиоцу пројекта
            </span>
        </h1>
        <form action="">
            <fieldset class="fieldset">
                <legend class="fieldset-legend">Претрага по подносиоцу пројекта</legend>
                <div class="grid">
                    <div class="grid-cell u-full u-xmed-1of3 fieldset-item">
                        <label for="media-name" class="fieldset-label">Подносилац по кључној речи</label>
                        <input type="text" v-model="submitterKeyword" placeholder="Унесите текст за претрагу"
                            class="input_reg" />

                    </div>
                    <div class="grid-cell u-full u-xmed-1of2 fieldset-item">
                        <label for="selectedSubmitter" class="fieldset-label">Подносилац пројекта (Можете изабрати више
                            подносилаца)</label>
                        <VueSelect v-model="selectedSubmitter" :options="submitters" label="name" track-by="id"
                            multiple>
                            <template #no-options>
                                Нема резултата за унету претрагу!
                            </template>
                        </VueSelect>
                    </div>

                    <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
                        <label for="date-from" class="fieldset-label">Датум од</label>
                        <VueDatePicker v-model="date.from" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'" :enable-time-picker="false"
                            :auto-apply="true"  locale="sr" placeholder="Од датума" input-class-name="input" />
                    </div>

                    <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
                        <label for="date-to" class="fieldset-label">Датум до</label>
                        <VueDatePicker v-model="date.to" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'" :enable-time-picker="false"
                            :auto-apply="true" locale="sr" placeholder="До датума" input-class-name="input" />
                    </div>

                    <div class="grid-cell u-full u-xmed-auto fieldset-item fieldset-item--noLabel">
                        <button @click.prevent="fetchData" class="button button--fieldset">Тражи</button>
                    </div>
                </div>
            </fieldset>
        </form>

        <div v-if="filteredDataSorted && filteredDataSorted.length" class="results">
            <h2 class="h2">Резултати претраге:</h2>
            <p class="fieldset-label">Укупaн број одобрених пројеката: <span>{{ filteredData.length }}</span></p>
            <p class="fieldset-label u-mb40">Укупaн износ предвиђених средстава: <span>{{ fundsSum }}</span> дин</p>

            <div class="table-wrap">
                <table class="table sticky-header">
                    <thead>
                        <tr class="table-row">
                            <th class="table-cell" @click="sortBy('township')" style="cursor:pointer">
                                Општина/Град
                                <span :class="['sort-indicator', sortKey === 'township' && 'sort-indicator--active']">{{ sortKey === 'township' ? (sortOrders.township === 1 ? '▲' : '▼') : '↕' }}</span>
                            </th>
                            <th class="table-cell" @click="sortBy('submitter')" style="cursor:pointer">
                                Подносилац пројекта
                                <span :class="['sort-indicator', sortKey === 'submitter' && 'sort-indicator--active']">{{ sortKey === 'submitter' ? (sortOrders.submitter === 1 ? '▲' : '▼') : '↕' }}</span>
                            </th>
                            <th class="table-cell" @click="sortBy('name')" style="cursor:pointer">
                                Назив пројекта
                                <span :class="['sort-indicator', sortKey === 'name' && 'sort-indicator--active']">{{ sortKey === 'name' ? (sortOrders.name === 1 ? '▲' : '▼') : '↕' }}</span>
                            </th>
                            <th class="table-cell" @click="sortBy('date')" style="cursor:pointer">
                                Датум
                                <span :class="['sort-indicator', sortKey === 'date' && 'sort-indicator--active']">{{ sortKey === 'date' ? (sortOrders.date === 1 ? '▲' : '▼') : '↕' }}</span>
                            </th>
                            <th class="table-cell" @click="sortBy('commissionMembers')" style="cursor:pointer">
                                Изабрани чланови
                                <span :class="['sort-indicator', sortKey === 'commissionMembers' && 'sort-indicator--active']">{{ sortKey === 'commissionMembers' ? (sortOrders.commissionMembers === 1 ? '▲' : '▼') : '↕' }}</span>
                            </th>
                            <th class="table-cell" @click="sortBy('funds')" style="cursor:pointer">
                                Износ додељених средстава
                                <span :class="['sort-indicator', sortKey === 'funds' && 'sort-indicator--active']">{{ sortKey === 'funds' ? (sortOrders.funds === 1 ? '▲' : '▼') : '↕' }}</span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="project in filteredDataSorted" :key="project.id" class="table-row">
                            <td class="table-cell">
                                <router-link :to="`/konkurs/${project.contestId}#t`" target="_blank" rel="noopener">{{ project.township }}</router-link>
                            </td>
                            <td class="table-cell">
                                {{ project.submitter?.name }}
                            </td>
                            <td class="table-cell">
                                {{ project.name }}
                            </td>
                            <td class="table-cell">
                               {{ project.date?.toFormat('dd.MM.yyyy.') }}
                            </td>
                            <td class="table-cell">
                                <ul>
                                    <li v-for="member in filteredCommissionMembers(project.commissionMembers)"
                                        :key="member.id">
                                        {{ member.member_name }}
                                    </li>
                                </ul>
                            </td>
                            <td class="table-cell">
                                {{ `${project.funds.toLocaleString('sr')} RSD` }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script src="./ProjectSubmitter.js"></script>
<style scoped>
.input_reg {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: var(--radius);
}
</style>